import { GetInTouch } from './components/GetInTouch/GetInTouch';

export default function Contacts() {
  return (
    <>
      <GetInTouch />
    </>
  );
}
